
const PricingSection = () => {
  const packages = [
    {
      name: "Market Explorer",
      price: "Starting at $2,500",
      description: "Perfect for businesses testing international waters",
      features: [
        "1-2 target market analysis",
        "Basic compliance guidance",
        "Shipping setup for 1 region",
        "30-day email support",
        "Market entry strategy document"
      ],
      popular: false,
      cta: "Get Started"
    },
    {
      name: "Global Accelerator",
      price: "Starting at $7,500",
      description: "Comprehensive expansion for serious growth",
      features: [
        "3-5 target market analysis",
        "Full regulatory compliance",
        "Multi-region shipping setup",
        "Platform optimization",
        "90-day dedicated support",
        "Performance tracking dashboard"
      ],
      popular: true,
      cta: "Most Popular"
    },
    {
      name: "Enterprise Expansion",
      price: "Custom Pricing",
      description: "White-glove service for established brands",
      features: [
        "Unlimited market analysis",
        "Custom compliance solutions",
        "Dedicated account manager",
        "Priority technical support",
        "Quarterly strategy reviews",
        "Custom integrations & tools"
      ],
      popular: false,
      cta: "Contact Us"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Choose Your Expansion Package
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Flexible pricing options designed to match your business size and growth ambitions. 
            All packages include our proven methodology and ongoing support.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <div key={index} className={`relative rounded-xl p-8 ${pkg.popular ? 'bg-teal-50 border-2 border-teal-500' : 'bg-gray-50 border border-gray-200'}`}>
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-teal-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    Most Popular
                  </span>
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                <div className="text-3xl font-bold text-teal-600 mb-2">{pkg.price}</div>
                <p className="text-gray-600">{pkg.description}</p>
              </div>

              <ul className="space-y-4 mb-8">
                {pkg.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <i className="ri-check-line text-teal-600 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button className={`w-full py-4 rounded-lg font-semibold transition-colors whitespace-nowrap ${
                pkg.popular 
                  ? 'bg-teal-600 hover:bg-teal-700 text-white' 
                  : 'bg-white hover:bg-gray-50 text-teal-600 border-2 border-teal-600'
              }`}>
                {pkg.cta}
              </button>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Not sure which package is right for you?
          </p>
          <button className="text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap">
            Schedule a free consultation to discuss your needs →
          </button>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
